module.exports = __webpack_public_path__ + "media/stylesheets/opensans700-00fb2fb77ba911c3cabcaa63c6ca2bce.woff2";